module.exports = __webpack_public_path__ + "static/media/IMG_6960 edit.363d56e9.jpg";